import React, { useState } from "react";
import {
    Search,
    Plus,
    Edit,
    Trash2,
    Eye,
    MapPin,
    Phone,
    CalendarDays,
    X,
    Building2,
    Power,
    AlertTriangle,
} from "lucide-react";

const stateDistricts = {
    "Tamil Nadu": [
        "Ariyalur",
        "Chengalpattu",
        "Chennai",
        "Coimbatore",
        "Cuddalore",
        "Dharmapuri",
        "Dindigul",
        "Erode",
        "Kallakurichi",
        "Kancheepuram",
        "Karur",
        "Krishnagiri",
        "Madurai",
        "Mayiladuthurai",
        "Nagapattinam",
        "Namakkal",
        "Nilgiris",
        "Perambalur",
        "Pudukkottai",
        "Ramanathapuram",
        "Ranipet",
        "Salem",
        "Sivaganga",
        "Tenkasi",
        "Thanjavur",
        "Theni",
        "Thoothukudi",
        "Tiruchirappalli",
        "Tirunelveli",
        "Tirupathur",
        "Tiruppur",
        "Tiruvallur",
        "Tiruvannamalai",
        "Tiruvarur",
        "Vellore",
        "Viluppuram",
        "Virudhunagar",
    ],

    Kerala: [
        "Alappuzha",
        "Ernakulam",
        "Idukki",
        "Kannur",
        "Kasaragod",
        "Kollam",
        "Kottayam",
        "Kozhikode",
        "Malappuram",
        "Palakkad",
        "Pathanamthitta",
        "Thiruvananthapuram",
        "Thrissur",
        "Wayanad",
    ],

    Karnataka: [
        "Bagalkot",
        "Bangalore Urban",
        "Belagavi",
        "Bellary",
        "Bidar",
        "Chamarajanagar",
        "Chikkaballapur",
        "Chikkamagaluru",
        "Chitradurga",
        "Dakshina Kannada",
        "Davanagere",
        "Dharwad",
        "Gadag",
        "Hassan",
        "Haveri",
        "Kalaburagi",
        "Kodagu",
        "Kolar",
        "Koppal",
        "Mandya",
        "Mysuru",
        "Raichur",
        "Ramanagara",
        "Shivamogga",
        "Tumakuru",
        "Udupi",
        "Uttara Kannada",
        "Vijayapura",
        "Yadgir",
    ],

    "Andhra Pradesh": [
        "Anakapalli",
        "Anantapur",
        "Bapatla",
        "Chittoor",
        "East Godavari",
        "Eluru",
        "Guntur",
        "Kakinada",
        "Krishna",
        "Kurnool",
        "Nandyal",
        "Nellore",
        "Palnadu",
        "Prakasam",
        "Srikakulam",
        "Tirupati",
        "Visakhapatnam",
        "Vizianagaram",
        "West Godavari",
    ],

    Telangana: [
        "Adilabad",
        "Hyderabad",
        "Jagitial",
        "Jangaon",
        "Jayashankar Bhupalpally",
        "Jogulamba Gadwal",
        "Kamareddy",
        "Karimnagar",
        "Khammam",
        "Komaram Bheem",
        "Mahabubabad",
        "Mahbubnagar",
        "Mancherial",
        "Medak",
        "Medchal",
        "Mulugu",
        "Nagarkurnool",
        "Nalgonda",
        "Nirmal",
        "Nizamabad",
        "Peddapalli",
        "Rajanna Sircilla",
        "Rangareddy",
        "Sangareddy",
        "Siddipet",
        "Suryapet",
        "Vikarabad",
        "Wanaparthy",
        "Warangal",
        "Yadadri Bhuvanagiri",
    ],

    Puducherry: [
        "Puducherry",
        "Karaikal",
        "Mahe",
        "Yanam",
    ],
};

const initialBranches = [
    {
        id: 1,
        name: "Erode Branch",
        address1: "123, Main Road",
        address2: "Near Bus Stand",
        state: "Tamil Nadu",
        district: "Erode",
        pincode: "638001",
        mobile: "9876543210",
        joiningDate: "2026-04-01",
        howKnow: "Google",
        status: "Active",
    },
    {
        id: 2,
        name: "Coimbatore Branch",
        address1: "45, Avinashi Road",
        address2: "Peelamedu",
        state: "Tamil Nadu",
        district: "Coimbatore",
        pincode: "641004",
        mobile: "9876543211",
        joiningDate: "2026-05-15",
        howKnow: "Friend / Reference",
        status: "Active",
    },
];

const emptyForm = {
    branchName: "",
    address1: "",
    address2: "",
    state: "",
    district: "",
    pincode: "",
    mobile: "",
    joiningDate: "",
    howKnow: "",
    status: "Active",
};

function Branches() {

    const [branches, setBranches] = useState(initialBranches);

    const [search, setSearch] = useState("");

    const [showForm, setShowForm] = useState(false);

    const [showViewModal, setShowViewModal] = useState(false);

    const [showDeleteModal, setShowDeleteModal] = useState(false);

    const [editingBranch, setEditingBranch] = useState(null);

    const [viewingBranch, setViewingBranch] = useState(null);

    const [deletingBranch, setDeletingBranch] = useState(null);

    const [formData, setFormData] = useState(emptyForm);

    const isEditMode = Boolean(editingBranch);

    /* =========================
       FORM CHANGE
    ========================= */

    const handleChange = (e) => {

        const { name, value } = e.target;

        setFormData((prev) => {

            if (name === "state") {

                return {
                    ...prev,
                    state: value,
                    district: "",
                };
            }

            return {
                ...prev,
                [name]: value,
            };
        });
    };

    /* =========================
       OPEN CREATE
    ========================= */

    const openCreateModal = () => {

        setEditingBranch(null);

        setFormData(emptyForm);

        setShowForm(true);
    };

    /* =========================
       OPEN EDIT
    ========================= */

    const openEditModal = (branch) => {

        setEditingBranch(branch);

        setFormData({
            branchName: branch.name,
            address1: branch.address1,
            address2: branch.address2,
            state: branch.state,
            district: branch.district,
            pincode: branch.pincode,
            mobile: branch.mobile,
            joiningDate: branch.joiningDate,
            howKnow: branch.howKnow,
            status: branch.status,
        });

        setShowForm(true);
    };

    /* =========================
       CLOSE FORM
    ========================= */

    const closeFormModal = () => {

        setShowForm(false);

        setEditingBranch(null);

        setFormData(emptyForm);
    };

    /* =========================
       SUBMIT
    ========================= */

    const handleSubmit = (e) => {

        e.preventDefault();

        if (editingBranch) {

            setBranches((prev) =>
                prev.map((branch) =>
                    branch.id === editingBranch.id
                        ? {
                            ...branch,
                            name: formData.branchName,
                            address1: formData.address1,
                            address2: formData.address2,
                            state: formData.state,
                            district: formData.district,
                            pincode: formData.pincode,
                            mobile: formData.mobile,
                            joiningDate: formData.joiningDate,
                            howKnow: formData.howKnow,
                            status: formData.status,
                        }
                        : branch
                )
            );

        } else {

            const newBranch = {
                id: Date.now(),
                name: formData.branchName,
                address1: formData.address1,
                address2: formData.address2,
                state: formData.state,
                district: formData.district,
                pincode: formData.pincode,
                mobile: formData.mobile,
                joiningDate: formData.joiningDate,
                howKnow: formData.howKnow,
                status: formData.status,
            };

            setBranches((prev) => [
                ...prev,
                newBranch,
            ]);
        }

        closeFormModal();
    };

    /* =========================
       VIEW
    ========================= */

    const openViewModal = (branch) => {

        setViewingBranch(branch);

        setShowViewModal(true);
    };

    /* =========================
       DELETE
    ========================= */

    const openDeleteModal = (branch) => {

        setDeletingBranch(branch);

        setShowDeleteModal(true);
    };

    const confirmDelete = () => {

        if (!deletingBranch) return;

        setBranches((prev) =>
            prev.filter(
                (branch) =>
                    branch.id !== deletingBranch.id
            )
        );

        setDeletingBranch(null);

        setShowDeleteModal(false);
    };

    /* =========================
       STATUS
    ========================= */

    const toggleStatus = (branch) => {

        setBranches((prev) =>
            prev.map((item) =>
                item.id === branch.id
                    ? {
                        ...item,
                        status:
                            item.status === "Active"
                                ? "Inactive"
                                : "Active",
                    }
                    : item
            )
        );
    };

    /* =========================
       SEARCH
    ========================= */

    const filteredBranches = branches.filter(
        (branch) =>
            branch.name
                .toLowerCase()
                .includes(search.toLowerCase()) ||
            branch.district
                .toLowerCase()
                .includes(search.toLowerCase()) ||
            branch.mobile.includes(search)
    );

    const activeBranches = branches.filter(
        (branch) =>
            branch.status === "Active"
    ).length;

    const inactiveBranches = branches.filter(
        (branch) =>
            branch.status === "Inactive"
    ).length;

    return (
        <div className="branches-page">

            {/* =========================
                PAGE HEADER
            ========================= */}

            <div className="page-header">

                <div>
                    <div className="breadcrumb">
                        Super Admin / Branches
                    </div>

                    <h1>Branches</h1>

                    <p>
                        Manage Jodi Point branches and branch information.
                    </p>
                </div>

                <button
                    className="primary-button"
                    onClick={openCreateModal}
                >
                    <Plus size={18} />
                    Create Branch
                </button>

            </div>

            {/* =========================
                SUMMARY
            ========================= */}

            <div className="branch-summary">

                <div className="summary-card">

                    <div className="summary-icon blue">
                        <Building2 size={21} />
                    </div>

                    <div>
                        <span>Total Branches</span>
                        <strong>
                            {branches.length}
                        </strong>
                    </div>

                </div>

                <div className="summary-card">

                    <div className="summary-icon green">
                        <Power size={21} />
                    </div>

                    <div>
                        <span>Active Branches</span>
                        <strong>
                            {activeBranches}
                        </strong>
                    </div>

                </div>

                <div className="summary-card">

                    <div className="summary-icon pink">
                        <Power size={21} />
                    </div>

                    <div>
                        <span>Inactive Branches</span>
                        <strong>
                            {inactiveBranches}
                        </strong>
                    </div>

                </div>

            </div>

            {/* =========================
                LIST
            ========================= */}

            <div className="branches-card">

                <div className="list-header">

                    <div>
                        <h2>Branch List</h2>

                        <span>
                            {filteredBranches.length} branches found
                        </span>
                    </div>

                    <div className="branch-search">

                        <Search size={18} />

                        <input
                            type="text"
                            placeholder="Search branch..."
                            value={search}
                            onChange={(e) =>
                                setSearch(e.target.value)
                            }
                        />

                    </div>

                </div>

                <div className="table-wrapper">

                    <table className="branch-table">

                        <thead>

                            <tr>
                                <th>Branch</th>
                                <th>Location</th>
                                <th>Mobile</th>
                                <th>Joining Date</th>
                                <th>Status</th>
                                <th>Actions</th>
                            </tr>

                        </thead>

                        <tbody>

                            {filteredBranches.map(
                                (branch) => (

                                    <tr key={branch.id}>

                                        <td>

                                            <div className="branch-name-cell">

                                                <div className="branch-avatar">
                                                    {branch.name
                                                        .charAt(0)
                                                        .toUpperCase()}
                                                </div>

                                                <div>

                                                    <strong>
                                                        {branch.name}
                                                    </strong>

                                                    <span>
                                                        {branch.howKnow ||
                                                            "—"}
                                                    </span>

                                                </div>

                                            </div>

                                        </td>

                                        <td>

                                            <div className="location-cell">

                                                <strong>
                                                    {branch.district}
                                                </strong>

                                                <span>
                                                    {branch.state} -{" "}
                                                    {branch.pincode}
                                                </span>

                                            </div>

                                        </td>

                                        <td>

                                            <div className="mobile-cell">

                                                <Phone size={15} />

                                                {branch.mobile}

                                            </div>

                                        </td>

                                        <td>

                                            <div className="date-cell">

                                                <CalendarDays
                                                    size={15}
                                                />

                                                {branch.joiningDate}

                                            </div>

                                        </td>

                                        <td>

                                            <button
                                                type="button"
                                                className={`status-badge ${
                                                    branch.status ===
                                                    "Active"
                                                        ? "active"
                                                        : "inactive"
                                                }`}
                                                onClick={() =>
                                                    toggleStatus(branch)
                                                }
                                            >
                                                {branch.status}
                                            </button>

                                        </td>

                                        <td>

                                            <div className="action-buttons">

                                                <button
                                                    className="action-button view"
                                                    title="View"
                                                    onClick={() =>
                                                        openViewModal(
                                                            branch
                                                        )
                                                    }
                                                >
                                                    <Eye size={16} />
                                                </button>

                                                <button
                                                    className="action-button edit"
                                                    title="Edit"
                                                    onClick={() =>
                                                        openEditModal(
                                                            branch
                                                        )
                                                    }
                                                >
                                                    <Edit size={16} />
                                                </button>

                                                <button
                                                    className="action-button delete"
                                                    title="Delete"
                                                    onClick={() =>
                                                        openDeleteModal(
                                                            branch
                                                        )
                                                    }
                                                >
                                                    <Trash2 size={16} />
                                                </button>

                                            </div>

                                        </td>

                                    </tr>

                                )
                            )}

                        </tbody>

                    </table>

                    {filteredBranches.length === 0 && (
                        <div className="empty-state">

                            <Building2 size={42} />

                            <h3>
                                No branches found
                            </h3>

                            <p>
                                Try another search or create a new branch.
                            </p>

                        </div>
                    )}

                </div>

            </div>

            {/* ==================================================
                CREATE / EDIT MODAL
            ================================================== */}

            {showForm && (

                <div className="branch-modal-overlay">

                    <div className="branch-modal">

                        <div className="modal-header">

                            <div>

                                <h2>
                                    {isEditMode
                                        ? "Edit Branch"
                                        : "Create Branch"}
                                </h2>

                                <p>
                                    {isEditMode
                                        ? "Update branch information."
                                        : "Add a new Jodi Point branch."}
                                </p>

                            </div>

                            <button
                                className="modal-close"
                                onClick={closeFormModal}
                            >
                                <X size={21} />
                            </button>

                        </div>

                        <form
                            className="branch-form"
                            onSubmit={handleSubmit}
                        >

                            <div className="form-section-title">
                                Branch Information
                            </div>

                            {/* Branch Name */}

                            <div className="form-field full">

                                <label>
                                    Branch Name
                                    <span>*</span>
                                </label>

                                <input
                                    type="text"
                                    name="branchName"
                                    value={formData.branchName}
                                    onChange={handleChange}
                                    placeholder="Enter branch name"
                                    required
                                />

                            </div>

                            {/* Address 1 */}

                            <div className="form-field full">

                                <label>
                                    Address Line 1
                                    <span>*</span>
                                </label>

                                <input
                                    type="text"
                                    name="address1"
                                    value={formData.address1}
                                    onChange={handleChange}
                                    placeholder="Enter address line 1"
                                    required
                                />

                            </div>

                            {/* Address 2 */}

                            <div className="form-field full">

                                <label>
                                    Address Line 2
                                </label>

                                <input
                                    type="text"
                                    name="address2"
                                    value={formData.address2}
                                    onChange={handleChange}
                                    placeholder="Enter address line 2"
                                />

                            </div>

                            {/* STATE FIRST */}

                            <div className="form-field">

                                <label>
                                    State
                                    <span>*</span>
                                </label>

                                <select
                                    name="state"
                                    value={formData.state}
                                    onChange={handleChange}
                                    required
                                >

                                    <option value="">
                                        Select state
                                    </option>

                                    {Object.keys(
                                        stateDistricts
                                    ).map((state) => (
                                        <option
                                            key={state}
                                            value={state}
                                        >
                                            {state}
                                        </option>
                                    ))}

                                </select>

                            </div>

                            {/* DISTRICT SECOND */}

                            <div className="form-field">

                                <label>
                                    District
                                    <span>*</span>
                                </label>

                                <select
                                    name="district"
                                    value={formData.district}
                                    onChange={handleChange}
                                    disabled={!formData.state}
                                    required
                                >

                                    <option value="">
                                        {formData.state
                                            ? "Select district"
                                            : "Select state first"}
                                    </option>

                                    {formData.state &&
                                        stateDistricts[
                                            formData.state
                                        ]?.map(
                                            (district) => (
                                                <option
                                                    key={district}
                                                    value={district}
                                                >
                                                    {district}
                                                </option>
                                            )
                                        )}

                                </select>

                            </div>

                            {/* PIN CODE */}

                            <div className="form-field">

                                <label>
                                    Pin Code
                                    <span>*</span>
                                </label>

                                <input
                                    type="text"
                                    name="pincode"
                                    value={formData.pincode}
                                    onChange={handleChange}
                                    placeholder="6 digit PIN code"
                                    maxLength="6"
                                    pattern="[0-9]{6}"
                                    required
                                />

                            </div>

                            {/* MOBILE */}

                            <div className="form-field">

                                <label>
                                    Mobile Number
                                    <span>*</span>
                                </label>

                                <input
                                    type="tel"
                                    name="mobile"
                                    value={formData.mobile}
                                    onChange={handleChange}
                                    placeholder="10 digit mobile number"
                                    maxLength="10"
                                    pattern="[0-9]{10}"
                                    required
                                />

                            </div>

                            {/* JOINING DATE */}

                            <div className="form-field">

                                <label>
                                    Joining Date
                                    <span>*</span>
                                </label>

                                <input
                                    type="date"
                                    name="joiningDate"
                                    value={formData.joiningDate}
                                    onChange={handleChange}
                                    required
                                />

                            </div>

                            {/* HOW KNOW */}

                            <div className="form-field">

                                <label>
                                    How Did You Know About Us?
                                </label>

                                <select
                                    name="howKnow"
                                    value={formData.howKnow}
                                    onChange={handleChange}
                                >

                                    <option value="">
                                        Select option
                                    </option>

                                    <option value="Google">
                                        Google
                                    </option>

                                    <option value="Facebook">
                                        Facebook
                                    </option>

                                    <option value="Instagram">
                                        Instagram
                                    </option>

                                    <option value="YouTube">
                                        YouTube
                                    </option>

                                    <option value="WhatsApp">
                                        WhatsApp
                                    </option>

                                    <option value="Friend / Reference">
                                        Friend / Reference
                                    </option>

                                    <option value="Advertisement">
                                        Advertisement
                                    </option>

                                    <option value="Website">
                                        Website
                                    </option>

                                    <option value="Other">
                                        Other
                                    </option>

                                </select>

                            </div>

                            {/* STATUS */}

                            <div className="form-field">

                                <label>
                                    Branch Status
                                    <span>*</span>
                                </label>

                                <select
                                    name="status"
                                    value={formData.status}
                                    onChange={handleChange}
                                    required
                                >

                                    <option value="Active">
                                        Active
                                    </option>

                                    <option value="Inactive">
                                        Inactive
                                    </option>

                                </select>

                            </div>

                            {/* ACTIONS */}

                            <div className="form-actions">

                                <button
                                    type="button"
                                    className="secondary-button"
                                    onClick={closeFormModal}
                                >
                                    Cancel
                                </button>

                                <button
                                    type="submit"
                                    className="primary-button"
                                >
                                    {isEditMode ? (
                                        <>
                                            <Edit size={17} />
                                            Update Branch
                                        </>
                                    ) : (
                                        <>
                                            <Plus size={17} />
                                            Create Branch
                                        </>
                                    )}
                                </button>

                            </div>

                        </form>

                    </div>

                </div>

            )}

            {/* ==================================================
                VIEW MODAL
            ================================================== */}

            {showViewModal && viewingBranch && (

                <div className="branch-modal-overlay">

                    <div className="branch-view-modal">

                        <div className="modal-header">

                            <div>

                                <h2>
                                    Branch Details
                                </h2>

                                <p>
                                    View branch information
                                </p>

                            </div>

                            <button
                                className="modal-close"
                                onClick={() =>
                                    setShowViewModal(false)
                                }
                            >
                                <X size={21} />
                            </button>

                        </div>

                        <div className="branch-view-content">

                            <div className="branch-view-profile">

                                <div className="large-branch-avatar">
                                    {viewingBranch.name
                                        .charAt(0)
                                        .toUpperCase()}
                                </div>

                                <div>

                                    <h3>
                                        {viewingBranch.name}
                                    </h3>

                                    <span
                                        className={`status-badge ${
                                            viewingBranch.status ===
                                            "Active"
                                                ? "active"
                                                : "inactive"
                                        }`}
                                    >
                                        {viewingBranch.status}
                                    </span>

                                </div>

                            </div>

                            <div className="view-details-grid">

                                <div className="view-detail">
                                    <label>
                                        Address Line 1
                                    </label>
                                    <strong>
                                        {viewingBranch.address1 ||
                                            "—"}
                                    </strong>
                                </div>

                                <div className="view-detail">
                                    <label>
                                        Address Line 2
                                    </label>
                                    <strong>
                                        {viewingBranch.address2 ||
                                            "—"}
                                    </strong>
                                </div>

                                <div className="view-detail">
                                    <label>
                                        State
                                    </label>
                                    <strong>
                                        {viewingBranch.state}
                                    </strong>
                                </div>

                                <div className="view-detail">
                                    <label>
                                        District
                                    </label>
                                    <strong>
                                        {viewingBranch.district}
                                    </strong>
                                </div>

                                <div className="view-detail">
                                    <label>
                                        Pin Code
                                    </label>
                                    <strong>
                                        {viewingBranch.pincode}
                                    </strong>
                                </div>

                                <div className="view-detail">
                                    <label>
                                        Mobile Number
                                    </label>
                                    <strong>
                                        {viewingBranch.mobile}
                                    </strong>
                                </div>

                                <div className="view-detail">
                                    <label>
                                        Joining Date
                                    </label>
                                    <strong>
                                        {viewingBranch.joiningDate}
                                    </strong>
                                </div>

                                <div className="view-detail">
                                    <label>
                                        How Did You Know?
                                    </label>
                                    <strong>
                                        {viewingBranch.howKnow ||
                                            "—"}
                                    </strong>
                                </div>

                            </div>

                        </div>

                        <div className="view-modal-footer">

                            <button
                                className="secondary-button"
                                onClick={() =>
                                    setShowViewModal(false)
                                }
                            >
                                Close
                            </button>

                            <button
                                className="primary-button"
                                onClick={() => {
                                    setShowViewModal(false);
                                    openEditModal(
                                        viewingBranch
                                    );
                                }}
                            >
                                <Edit size={17} />
                                Edit Branch
                            </button>

                        </div>

                    </div>

                </div>

            )}

            {/* ==================================================
                DELETE CONFIRMATION
            ================================================== */}

            {showDeleteModal && deletingBranch && (

                <div className="branch-modal-overlay">

                    <div className="delete-modal">

                        <div className="delete-warning-icon">
                            <AlertTriangle size={28} />
                        </div>

                        <h2>
                            Delete Branch?
                        </h2>

                        <p>
                            Are you sure you want to delete{" "}
                            <strong>
                                {deletingBranch.name}
                            </strong>
                            ? This action cannot be undone.
                        </p>

                        <div className="delete-modal-actions">

                            <button
                                className="secondary-button"
                                onClick={() => {
                                    setShowDeleteModal(false);
                                    setDeletingBranch(null);
                                }}
                            >
                                Cancel
                            </button>

                            <button
                                className="delete-confirm-button"
                                onClick={confirmDelete}
                            >
                                <Trash2 size={17} />
                                Delete Branch
                            </button>

                        </div>

                    </div>

                </div>

            )}

        </div>
    );
}

export default Branches;